export const SOURCE_BLOCK_ID_QUERY_PARAM_NAME = 'source-block';
